import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import "./potable.css";

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#103A5D",
      color: "white",
      fontSize: "14px",
      fontFamily: "Sarabun",
      fontStyle: "normal",
      fontWeight: 400,
    },
  },
};

const HistoryTable = ({ poHistory }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    if (poHistory && Array.isArray(poHistory)) {
      setHistoryData(poHistory);
    } else {
      setHistoryData([]);
    }
  }, [poHistory]);

  const columns = [
   
    {
      name: `${t("PO No")}`,
      selector: (row) => row.poNo,
      sortable: true,
    },
    {
      name: `${t("Version")}`,
      selector: (row) => row.version,
      sortable: true,
    },
    {
      name: `${t("Created At")}`,
      selector: (row) => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
    },
    {
      name: `${t("Action")}`,
      width: "150px",
      cell: (row) => (
        <button
          className="dashboard-main-page-pr-view"
          onClick={() => navigate(`/po-history-details/${row?.poDbId}/${row.id}`)}
        >
          View PO
        </button>
      ),
    },
  ];

  const totalCount = historyData.length;

  return (
    <>
      <div className="dahsboard-main-page-tables">
        <div className="pt-3">
          <DataTable
            className="vendor-dashboard-pr-table"
            columns={columns}
            data={historyData}
            customStyles={customStyles}
            pagination={false}
            noDataComponent="No records to display"
            persistTableHead
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center pb-5">
        <p className="table-show-entries">
          Showing {totalCount} {totalCount === 1 ? 'entry' : 'entries'}
        </p>
      </div>
    </>
  );
};

export default HistoryTable;